<template>
    <div class="new-subject-component">
        <div class="new-subject-body">
            <b-form data-vv-scope="new-subject-form">
                <b-row class="subject">
                    <b-col sm="3">
                        <label for="input-subject-name">Semester</label>
                    </b-col>
                    <b-col sm="9">
                        <b-form-select
                            v-model="add_subject_form.semester"
                            name="semester"
                            data-vv-as="Semester"
                            :options="semesterList"
                            v-validate="'required'"
                        ></b-form-select>
                        <span :class="{ 'error-validation': errors.first('new-subject-form.semester') }">{{ errors.first('new-subject-form.semester') }}</span>
                    </b-col>
                    <b-col sm="3">
                        <label for="input-subject-name">Nama Mata Pelajaran</label>
                    </b-col>
                    <b-col sm="9">
                        <b-form-input
                        id="input-subject-name"
                        name="subject_name"
                        data-vv-as="Nama mata pelajaran"
                        v-model="add_subject_form.name"
                        type="text"
                        placeholder="Nama Mata Pelajaran"
                        v-validate="'required'"
                        autocomplete="off"
                        ></b-form-input>
                        <span :class="{ 'error-validation': errors.first('new-subject-form.subject_name') }">{{ errors.first('new-subject-form.subject_name') }}</span>
                    </b-col>
                </b-row>
            </b-form>
        </div>
        <hr>
        <div class="new-class-footer d-flex justify-content-end">
            <square-loader :loading="showLoader" :color="'#ca062a'" :size="'30px'"></square-loader>
            <b-button v-if="!showLoader" variant="outline-danger" size="md" style="width: 25%;" @click="hideAddSubjectModal">BATAL</b-button>
            <b-button v-if="!showLoader" variant="primary" size="md" style="width: 25%;" @click.prevent="saveNewSubject">SIMPAN</b-button>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '@/eventBus.js'
    import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
    export default {
        props: {
            classId: {
                type: String,
                default: null
            },
            semesterList: {
                type: Array,
                default () {
                    return [
                        {
                            value : '1',
                            text : 'Ganjil',
                        },
                        {
                            value : '2',
                            text : 'Genap',
                        },
                    ]
                }
            },
        },
        components: {
            SquareLoader
        },
        data() {
            return {
                showLoader: false,
                add_subject_form: {
                    name: null,
                    semester: 1,
                }
            };
        },
        methods: {
            resetAddSubjectForm() {
                this.add_subject_form.name = null
                this.add_subject_form.semester = 1
                this.$validator.reset()
            },
            hideAddSubjectModal() {
                EventBus.$emit('hideAddSubjectModal', true)
            },
            async saveNewSubject() {
                let scope = 'new-subject-form'
                this.$validator.validateAll(scope).then(valid => {
                    if (valid) {
                        this.showLoader = true
                        let form = {
                            class_id: this.classId,
                            name: this.add_subject_form.name,
                            semester: this.add_subject_form.semester
                        }
						this.$store.dispatch('addSubject', form)
							.then((res) => {
                                this.showLoader = false
                                let classId = this.classId
                                this.$store.dispatch('getClassDetail', { classId })
                                this.hideAddSubjectModal()
                                this.$swal.fire('Success', res.message, 'success')
							})
							.catch((err)=> {
                                this.showLoader = false
                                this.$swal.fire('Failed', err.response.data.message, 'error')
							})
                    }
                });
            },
        },
		created () {
			EventBus.$on('resetAddSubjectForm', (val) => {
				if (val) {
					this.resetAddSubjectForm()
				}
			})
        }
    }
</script>